<script setup>
import { CAMPAIGN_CONFIG } from '../config.js'
import { useNextVoteText } from '../composables/nextVoteText'

const { copy } = CAMPAIGN_CONFIG
const { nextVoteText } = useNextVoteText()
</script>

<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <div class="text-xl text-white" v-html="copy.alreadyVoted(nextVoteText)" />
</template>
